import { CompanyAbout } from '@/lib/widgets/about/company-about';
import { CompanyHistory } from '@/lib/widgets/about/company-history';
import { CompanyValues } from '@/lib/widgets/about/company-values';
import { ValuesSlider } from '@/lib/widgets/about/values-slider';

// import { WeAreTrusted } from "@/lib/ui/blocks/common/WeAreTrusted";
import { IMainPage, ISocialsData } from '@/lib/entities/page';

import { CallBack } from '@/lib/shared/blocks/CallBack';
import { CompanyBenefits } from '@/lib/shared/blocks/CompanyBenefits';
import { ShareContent } from '@/lib/shared/blocks/ShareContent';
import { JoinOurTeam } from '@/lib/shared/components/JoinOurTeam';

import styles from './AboutPage.module.scss';

// import { CompanyTeam } from "@/lib/ui/blocks/page-specific/About/CompanyTeam";

interface IAboutPage {
  data: IMainPage;
  shareContent: ISocialsData;
  h1?: string | null;
}
export const AboutPage = ({ data, shareContent, h1 }: IAboutPage) => {
  return (
    <section className={styles.about}>
      <CompanyAbout h1={h1} />
      <CompanyBenefits />
      {/* <CompanyTeam /> */}
      <div className={styles.team}>
        <div className={styles.container}>
          <JoinOurTeam />
        </div>
      </div>

      <CompanyValues />
      <div className={styles.white}>
        <ValuesSlider data={data} />
      </div>
      <CompanyHistory />

      <CallBack
        page="about"
        buttonLabel={'submit'}
        agreementText={'agreementSubmit'}
        eventName={['others']}
      />
      {/* <div className={styles.background}>
        <WeAreTrusted isAboutPage />
      </div> */}
      <ShareContent data={shareContent} />
    </section>
  );
};
